class EnjpAccountForm extends HTMLElement {
    constructor() {
        super();
    }

    get forms() {
        return this.querySelectorAll('form[enjp-account-form]');
    }

    connectedCallback() {
        this.forms.forEach(form => {
            form.addEventListener('submit', (event) => {
                const isValid = this.validateForm(form);

                if (!isValid) {
                    event.preventDefault();
                    event.stopPropagation();
                    event.stopImmediatePropagation();
                    return false;
                }

                const emailInput = form.querySelector('#RegisterForm-email');
                const firstNameInput = form.querySelector('#RegisterForm-FirstName');
                const lastNameInput = form.querySelector('#RegisterForm-LastName');
                const newsletterCheckbox = form.querySelector('#RegisterForm-newsletter');

                console.log("Email:", emailInput ? emailInput.value : 'N/A');
                console.log("Newsletter checkbox value:", newsletterCheckbox ? newsletterCheckbox.value : 'N/A');
                console.log("Newsletter checkbox checked:", newsletterCheckbox ? newsletterCheckbox.checked : false);

                if (emailInput && emailInput.value && newsletterCheckbox && newsletterCheckbox.checked) {
                    const data = {
                        email: emailInput.value,
                        nome: firstNameInput.value || window.customer.first_name || "",
                        cognome: lastNameInput.value || window.customer.last_name || "",
                    }
                    publish(PUB_SUB_EVENTS.registerNewsletter, data);
                }
            }, true);
        });
    }


    resetFormErrors(form) {
        form.querySelectorAll('small[error]').forEach(errorElement => {
            errorElement.setAttribute('data-active', 'false');
        });
    }

    isEmpty(inputElement) {
        const value = inputElement.value?.trim();
        if (inputElement.type === 'checkbox' && !inputElement.checked) {
            this.setInputError(inputElement);
            return true;
        }
        if (!value) {
            this.setInputError(inputElement);
            return true;
        }
        return false;
    }

    setInputError(inputElement) {
        const inputError = this.getInputErrorElement(inputElement);
        if (inputError) {
            inputError.setAttribute('data-active', 'true');
        }
    }

    getInputErrorElement(inputElement) {
        return inputElement.closest('div')?.querySelector('small[error]') || null;
    }

    validateForm(form) {
        let isValid = true;
        this.resetFormErrors(form);
        const requiredInputs = form.querySelectorAll('input[required]');

        requiredInputs.forEach(input => {
            if (this.isEmpty(input)) {
                isValid = false;
            }
        });

        return isValid;
    }
}

customElements.define("account-form", EnjpAccountForm);
